import { render, staticRenderFns } from "./ObjectAdvertising.vue?vue&type=template&id=c644b046&scoped=true"
import script from "./ObjectAdvertising.vue?vue&type=script&lang=js"
export * from "./ObjectAdvertising.vue?vue&type=script&lang=js"
import style0 from "./ObjectAdvertising.vue?vue&type=style&index=0&id=c644b046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c644b046",
  null
  
)

export default component.exports